import { useRef } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router';
import Modal, { type ModalAction } from '@/components/common/modal/modal';
import ConditionalLayout from '@/components/layouts/conditional-layout';
import ROUTES from '@/routes';
import cn from '@/utils/merge-class-names';
import BatchMessagingRoute from '.';

export default function BatchMessageLayout() {
  const modalRef = useRef<ModalAction>(null);
  const navigate = useNavigate();
  const isPreviewMediaRoute = useMatch(ROUTES.MY.SETTINGS.MESSAGING.BATCH.PREVIEW.$path());
  const isCreateBatch = useMatch(ROUTES.MY.SETTINGS.MESSAGING.BATCH.CREATE.BY_ID.$path());
  return (
    <ConditionalLayout pathname={ROUTES.MY.SETTINGS.MESSAGING.BATCH.$path()}>
      {(isDesktop, isMatch) => {
        if (isDesktop) {
          return (
            <>
              {!isMatch && (
                <Modal
                  ref={modalRef}
                  contentClassName={cn('rounded-lg h-80dvh w-[400px]', {
                    'w-[800px] h-80dvh': isPreviewMediaRoute,
                    'h-80dvh w-[480px]': isCreateBatch,
                  })}
                  key='batch-message-modal'
                  defaultOpen={true}
                  fullScreen
                  onClose={() => {
                    navigate(-1);
                  }}
                  bottomCloseButton={!!isCreateBatch}>
                  <Outlet />
                </Modal>
              )}
              <BatchMessagingRoute />
            </>
          );
        }
        return <Outlet />;
      }}
    </ConditionalLayout>
  );
}
